import { render, staticRenderFns } from "./Ticket_Type_Manage.vue?vue&type=template&id=5338820e&"
import script from "./Ticket_Type_Manage.vue?vue&type=script&lang=js&"
export * from "./Ticket_Type_Manage.vue?vue&type=script&lang=js&"
import style0 from "./Ticket_Type_Manage.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports